import SvgAdd from '@sats-group/icons/16/add';
import Button from '@sats-group/ui-lib/react/button';
import React, { useRef } from 'react';
import { Dialog } from '~/source/ui/dialog/dialog';
import { EnrollOption } from './enroll-option';
import type { Enroll as Props } from './enroll.types';

export const Enroll: React.FC<Props> = ({
  close,
  id,
  open,
  options,
  title,
}) => {
  const dialog = useRef<HTMLDialogElement>(null);

  const handleCompletion = () => {
    if (dialog.current) {
      dialog.current.hidePopover();
    }
  };

  return (
    <div className="enroll">
      <Button
        leadingIcon={<SvgAdd />}
        popoverTarget={id}
        popoverTargetAction="show"
        size={Button.sizes.small}
        testId="enroll"
        text={open}
        variant={Button.variants.primary}
      />
      <Dialog close={close} id={id} ref={dialog} title={title}>
        <div className="enroll__options">
          {options.map(entry => (
            <div key={entry.id}>
              <EnrollOption {...entry} onCompletion={handleCompletion} />
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
};
